import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-editor-datetime",
  styleUrls: ["./editor-datetime.component.scss"],
  templateUrl: "./editor-datetime.component.html",
})
export class EditorDateTimeComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() datetime: Date = new Date();
  @Output() onChange: EventEmitter<Date> = new EventEmitter();

  inDate: Date = new Date();
  inTime: Date = new Date();

  constructor() {}

  ngOnInit(): void {
    this.inDate = moment(this.datetime).toDate();
    this.inTime = moment(this.datetime).toDate();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dateChange() {
    const today = new Date();
    const dateString =
      moment(this.inDate ? this.inDate : today).format("YYYY-MM-DD") +
      " " +
      moment(this.inTime ? this.inTime : today).format("HH:mm");

    this.datetime = moment(dateString).toDate();

    this.onChange.emit(this.datetime);
  }
}
